var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5102_18293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5102_18293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 27.3337V25.3337H26V27.3337H6ZM10.7563 22.154C9.44367 22.154 8.32278 21.6959 7.39367 20.7797C6.46456 19.8634 6 18.7575 6 17.462V4.66699H26.205C26.8819 4.66699 27.4614 4.90244 27.9437 5.37333C28.4257 5.84444 28.6667 6.41666 28.6667 7.08999V10.5773C28.6667 11.2507 28.4257 11.8229 27.9437 12.294C27.4614 12.7649 26.8819 13.0003 26.205 13.0003H23.5383V17.462C23.5383 18.7575 23.0739 19.8634 22.145 20.7797C21.2159 21.6959 20.0949 22.154 18.782 22.154H10.7563ZM10.7563 20.1543H18.782C19.54 20.1543 20.1889 19.8901 20.7287 19.3617C21.2684 18.8334 21.5383 18.1984 21.5383 17.4567V6.66699H8V17.4617C8 18.2037 8.26989 18.8379 8.80967 19.3643C9.34944 19.891 9.99833 20.1543 10.7563 20.1543ZM23.5383 11.0003H26.205C26.3332 11.0003 26.4422 10.9598 26.532 10.8787C26.6218 10.7973 26.6667 10.6969 26.6667 10.5773V7.08999C26.6667 6.97044 26.6218 6.86999 26.532 6.78866C26.4422 6.70755 26.3332 6.66699 26.205 6.66699H23.5383V11.0003ZM10.7563 20.1543H8H21.5383H10.7563Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.282117308881a944ade7d9d02301892b.svg";
export { ForwardRef as ReactComponent };